import _range from 'lodash/range';
import { toEmployerDate } from '../../utils/formatter';

function _isSameDateAs(date1, date2) {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
}

export function extractNLastFollowersByDate(lastNDays, followersByDate) {
    // only loop through the last N follow dates.
    // just for performance...
    const _followersByDate = followersByDate || [];
    const lastNFollowers = _followersByDate.slice(0, lastNDays);

    return _range(lastNDays).map((i) => {
        const d = new Date();
        d.setDate(d.getDate() - i);

        const followerOnThisDate = lastNFollowers.filter((f) =>
            _isSameDateAs(new Date(f.created), d)
        );

        return {
            date: toEmployerDate(d),
            count: followerOnThisDate.length ? followerOnThisDate[0].count : 0,
        };
    });
}

export function aggregateFollowersCount(lastNFollowers) {
    return lastNFollowers.reduce(
        (prevValue, currValue) => prevValue + currValue.count,
        0
    );
}
